import { FC, useContext } from 'react';

import {
  AuthContext,
  Heading,
  FeedbackForm,
  useForm,
  urls,
} from '@getstream/ui-library/build';

import Button from '../Button';
import CloudComponent from '../CloudComponent';
import Layout from '../Layout';
import Title from '../Title';
import Paragraph from '../Paragraph';

import { conclusion as chatConclusion } from '../../../data/chat/conclusion';
import { conclusion as feedsConclusion } from '../../../data/feeds/conclusion';
import { conclusion as videoConclusion } from '../../../data/video/conclusion';

import styles from './Conclusion.module.css';

import { Conclusion as ConclusionType } from '../../../types/tour';
import { Product } from '../../../types/tour';

export type ConclusionContent = {
  chat: ConclusionType;
  'activity-feeds': ConclusionType;
  video: ConclusionType;
};

const CONTENT: ConclusionContent = {
  chat: chatConclusion,
  'activity-feeds': feedsConclusion,
  video: videoConclusion,
};

export type Props = {
  product: Product.Chat | Product.ActivityFeeds | Product.Video;
};

export const Conclusion: FC<Props> = ({ product }) => {
  const { conclusion, docs, components }: ConclusionType = CONTENT[product];
  const { email, isLoggedIn }: any = useContext(AuthContext);

  return (
    <div className={styles.getStartedConclusion}>
      <div className={styles.getStartedConclusionContainer}>
        <Layout product={product}>
          <div className={styles.conclusion}>
            <div>
              <Title>Congratulations 🤗</Title>
              <Paragraph>{conclusion}</Paragraph>
            </div>
            <div className={styles.conclusionNextSteps}>
              {isLoggedIn ? (
                <Button
                  color="secondary"
                  size="small"
                  href={urls.dashboard}
                  external
                  shadow="default"
                  emphasis
                >
                  Go To Dashboard
                </Button>
              ) : (
                <Button
                  color="secondary"
                  size="small"
                  href={urls.chat.trial}
                  shadow="default"
                  emphasis
                >
                  Start Coding Free
                </Button>
              )}
              <Button
                size="small"
                href={docs.to}
                shadow="default"
                color="primary"
                emphasis
              >
                {docs.label}
              </Button>
            </div>
            {components && (
              <div className={styles.conclusionComponents}>
                <h4>Cloud components</h4>
                <ul className={styles.cloudComponentList}>
                  {components.map((component, key) => (
                    <CloudComponent
                      component={component}
                      key={`cloud-component-${key}`}
                    />
                  ))}
                </ul>
              </div>
            )}
          </div>
        </Layout>
      </div>
      <div className={styles.getStartedConclusionSidebar}>
        <Heading tag="h4">Give us Feedback!</Heading>
        <p className={styles.feedbackDescription}>
          Did you find this demo helpful? Either good or bad, we’re looking for
          your honest feedback so we can improve.
        </p>
        <FeedbackForm
          email={email}
          useForm={() =>
            useForm('doc', import.meta.env.VITE_API_BASEURL, {
              href: '/chat/get_started/',
            })
          }
        />
      </div>
    </div>
  );
};
